import React, { useState } from 'react';
import { Button } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { message } from 'antd';
import LessonPlanEditor from './LessonPlanEditor';
import { handleCreateOrUpdateLessonPlan, handleDeleteLessonPlanByBookAndUser, handleListLessonPlanByBookAndUser } from 'store/lesson_plan/thunks';
import { useCurrentUser } from 'store/users/selectors';

const LessonPlanEditButton = ({ 
  selectedPagePlan, 
  onDeleteSuccess,
  onPrintSingle,
  printLoader
}) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const dispatch = useDispatch();
  const currentUser = useCurrentUser();
  

  const handleEditClick = () => {
    setShowEditModal(true)
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  const handleUpdate = async (content) => {
    if (!selectedPagePlan) {
      message.error('No lesson plan found to update.');
      return;
    }

    setIsUpdating(true);
    const object_content = typeof content === 'object' && Object.keys(content).length > 0 ? content : {};
    const content_data = typeof content === 'string' ? content : content.content?content.content:selectedPagePlan.content;
    try {
      const updateData = {
        id: selectedPagePlan.id,
        chapter: selectedPagePlan.chapter || '',
        page_id: selectedPagePlan.page_id ,
        created_by: currentUser?.id,
        parent_id:selectedPagePlan.created_by === currentUser?.id ? selectedPagePlan.parent_id : selectedPagePlan.id,
        content: content_data,
        user_type: 'teacher',
        ...object_content
      };

      const result = await dispatch(handleCreateOrUpdateLessonPlan(updateData));
      
      if (result && !result.error) {
        message.success('Lesson plan updated successfully!');
        await dispatch(handleListLessonPlanByBookAndUser(selectedPagePlan.chapter,currentUser?.id));
        setShowEditModal(false);
      } else {
        message.error(result?.error || 'Failed to update lesson plan');
      }
    } catch (error) {
      console.error('Error updating lesson plan:', error);
      message.error('Failed to update lesson plan');
    } finally {
      setIsUpdating(false);
    }
  };

  const handleDelete = async () => {
    if (!selectedPagePlan?.id||selectedPagePlan.created_by !== currentUser?.id) {
      message.error('No lesson plan found to delete.');
      return;
    }

    setIsDeleting(true);
    
    try {
      const result = await dispatch(handleDeleteLessonPlanByBookAndUser(selectedPagePlan.id));
      
      if (result && !result.error) {
        message.success('Lesson plan deleted successfully!');
        await dispatch(handleListLessonPlanByBookAndUser(selectedPagePlan.chapter,currentUser?.id));
        setShowEditModal(false);
        if (onDeleteSuccess) {
          onDeleteSuccess();
        }
      } else {
        message.error(result?.error || 'Failed to delete lesson plan');
      }
    } catch (error) {
      console.error('Error deleting lesson plan:', error);
      message.error('Failed to delete lesson plan');
    } finally {
      setIsDeleting(false);
    }
  };

  if (!selectedPagePlan) {
    return null;
  }

  return (
    <>
      <Button
        variant="contained"
        color="success"
        startIcon={<Edit />}
        onClick={handleEditClick}
        size="small"
        style={{
          backgroundColor: '#28a745',
          color: 'white',
          fontSize: '12px',
          padding: '4px 8px',
          minWidth: 'auto',
        }}
      >
        Edit
      </Button>

      {/* Lesson Plan Edit Modal */}
      {showEditModal && selectedPagePlan && (
        <LessonPlanEditor
          open={showEditModal}
          onClose={handleCloseEditModal}
          existingLessonPlan={selectedPagePlan}
          onUpdate={handleUpdate}
          onDelete={handleDelete}
          isUpdating={isUpdating || isDeleting}
          title="Edit Lesson Plan"
          selectedPagePlan={selectedPagePlan}
          onPrintSingle={onPrintSingle}
          printLoader={printLoader}
        />
      )}
    </>
  );
};

export default LessonPlanEditButton;
